export const FETCH_EMPLOYEES = 'FETCH_EMPLOYEES';
export const FETCHING_EMPLOYEES = 'FETCHING_EMPLOYEES';
export const FETCH_EMPLOYEES_SUCCESS = 'FETCH_EMPLOYEES_SUCCESS';
export const FETCH_EMPLOYEES_FAILED = 'FETCH_EMPLOYEES_FAILED';

export const SET_EMPLOYEE = 'SET_EMPLOYEE';

export const FETCH_EMPLOYEE = 'FETCH_EMPLOYEE';
export const FETCHING_EMPLOYEE = 'FETCHING_EMPLOYEE';
export const FETCH_EMPLOYEE_SUCCESS = 'FETCH_EMPLOYEE_SUCCESS';
export const FETCH_EMPLOYEE_FAILED = 'FETCH_EMPLOYEE_FAILED';

export const SET_IMAGE = 'SET_EMPLOYEE_IMAGE';
export const ADD_TAG = 'ADD_EMPLOYEE_TAG';
export const REMOVE_TAG = 'REMOVE_EMPLOYEE_TAG';

export const ADD_PERMISSION = 'ADD_EMPLOYEE_PERMISSION';
export const REMOVE_PERMISSION = 'REMOVE_EMPLOYEE_PERMISSION';

// export const ADD_ROLE = 'ADD_EMPLOYEE_ROLE';
// export const REMOVE_ROLE = 'REMOVE_EMPLOYEE_ROLE';

export const SET_IMAGE_DOWNLOAD_URL = 'SET_IMAGE_DOWNLOAD_URL';

// export const SAVE_EMPLOYEE = 'SAVE_EMPLOYEE';
// export const SAVING_EMPLOYEE = 'SAVING_EMPLOYEE';
// export const SAVE_EMPLOYEE_SUCCESS = 'SAVE_EMPLOYEE_SUCCESS';
// export const SAVE_EMPLOYEE_FAILED = 'SAVE_EMPLOYEE_FAILED';

export function setEmployee(employee) {
  return {
    type: SET_EMPLOYEE,
    employee,
  };
}

export function fetchEmployees() {
  return {
    type: FETCH_EMPLOYEES,
  };
}

export function fetchingEmployees() {
  return {
    type: FETCHING_EMPLOYEES,
  };
}

export function fetchEmployeesSuccess(employees) {
  return {
    type: FETCH_EMPLOYEES_SUCCESS,
    employees,
  };
}
export function fetchEmployeesFailed(error) {
  return {
    type: FETCH_EMPLOYEES_FAILED,
    error,
  };
}

export function fetchEmployee(employeeId) {
  return {
    type: FETCH_EMPLOYEE,
    employeeId,
  };
}

export function fetchingEmployee(employeeId) {
  return {
    type: FETCHING_EMPLOYEE,
    employeeId,
  };
}

export function fetchEmployeeSuccess(employee) {
  return {
    type: FETCH_EMPLOYEE_SUCCESS,
    employee,
  };
}

export function fetchEmployeeFailed(employeeId, error) {
  return {
    type: FETCH_EMPLOYEE_FAILED,
    employeeId,
    error,
  };
}

export function setImage(employee, image) {
  return {
    type: SET_IMAGE,
    employee,
    image,
  };
}
export function setImageDownloadUrl(imageUrl) {
  return {
    type: SET_IMAGE_DOWNLOAD_URL,
    imageUrl,
  };
}

export function addTag(employee, tag) {
  return {
    type: ADD_TAG,
    employee,
    tag,
  };
}

export function removeTag(employee, tag) {
  return {
    type: REMOVE_TAG,
    employee,
    tag,
  };
}

export function addPermission(employee, permission) {
  return {
    type: ADD_PERMISSION,
    employee,
    permission,
  };
}

export function removePermission(employee, permission) {
  return {
    type: REMOVE_PERMISSION,
    employee,
    permission,
  };
}

// export function addRole(employee, role) {
//   return {
//     type: ADD_ROLE,
//     employee,
//     role,
//   };
// }
//
// export function removeRole(employee, role) {
//   return {
//     type: REMOVE_ROLE,
//     employee,
//     role,
//   };
// }

// export function saveEmployee(employee) {
//   return {
//     type: SAVE_EMPLOYEE,
//     employee,
//   };
// }
//
// export function savingEmployee(employee) {
//   return {
//     type: SAVING_EMPLOYEE,
//     employee,
//   };
// }
//
// export function saveEmployeeSuccess(employee) {
//   return {
//     type: SAVE_EMPLOYEE_SUCCESS,
//     employee,
//   };
// }
// export function saveEmployeeFailed(employee,error) {
//   return {
//     type: SAVE_EMPLOYEE_FAILED,
//     employee,
//     error,
//   };
// }



// WEBPACK FOOTER //
// ./src/actions/employees.js